import { useEffect, useState } from "react";
import useHoverDelay from "./useHoverDelay";
import { hover } from "../inlineCardSlice";
import { WritingAlert } from "../writingAlertsSlice";
import { useAppDispatch } from "../../../store/hooks";
import usePrevious from "./usePrevious";

type AlertSource = number;
type CardSource = "card";
type HoverSource = CardSource | AlertSource;

export interface HoverLogic {
  isHovering: boolean;
  markIsHovering: (source: HoverSource) => void;
  markIsNotHovering: (source: HoverSource) => void;
  forceNotHovering: (source: HoverSource) => void;
  CARD_SOURCE: CardSource;
  alertSource: (source: WritingAlert) => AlertSource;
}

export default function useUnderlineCardHover(): HoverLogic {
  const dispatch = useAppDispatch();
  const hoverState = useHoverDelay(125, 300);
  const wasHovering = usePrevious(hoverState.isHovering) || false;
  const [source, setSource] = useState<HoverSource>();

  useEffect(() => {
    if (hoverState.isHovering !== wasHovering) {
      dispatch(hover(hoverState.isHovering ? "start" : "stop"));
    }
  }, [dispatch, hoverState.isHovering, wasHovering]);

  return {
    isHovering: hoverState.isHovering,
    markIsHovering: (s) => {
      setSource(s);
      hoverState.markIsHovering();
    },
    markIsNotHovering: (s) => {
      // ensures that the source has to match the previous
      // the source that previously marked hovering
      // Avoids late or laggy markings from a different source
      // e.g. the underline marking 'not hovering' after the card
      // has started hovering
      if (source === undefined || s === source) {
        setSource(s);
        hoverState.markIsNotHovering();
      }
    },
    forceNotHovering: (s) => {
      setSource(s);
      hoverState.forceNotHovering();
    },
    CARD_SOURCE: "card",
    alertSource: (alert: WritingAlert) => {
      return alert.id;
    },
  };
}
